import {colorVehicleState, colorSpeedState} from './stateColors'

const vehicleStates = [
  { value: 'V0', name: 'En Movimiento', description: 'Velocidad mayor a 5km/h', avatar: colorSpeedState['SPEED_0'], selected: false },
  { divider: true },
  { header: 'Velocidad 0' },
  { value: 'S0', name: 'Estado 0', description: 'Quieto menor a 15 minutos', avatar: colorVehicleState['STATE_0'], selected: false },
  { value: 'S1', name: 'Estado 1', description: 'Quieto entre 15 y 30 minutos', avatar: colorVehicleState['STATE_1'], selected: false },
  { value: 'S2', name: 'Estado 2', description: 'Quieto entre 30 y 60 minutos', avatar: colorVehicleState['STATE_2'], selected: false },
  { value: 'S3', name: 'Estado 3', description: 'Quieto entre 60 y 120 minutos', avatar: colorVehicleState['STATE_3'], selected: false },
  { value: 'S4', name: 'Estado 4', description: 'Quieto entre 120 y 240 minutos', avatar: colorVehicleState['STATE_4'], selected: false },
  { value: 'S5', name: 'Estado 5', description: 'Quieto entre 240 y 480 minutos', avatar: colorVehicleState['STATE_5'], selected: false },
  { value: 'S6', name: 'Estado 6', description: 'Quieto entre 480 y 1440 minutos', avatar: colorVehicleState['STATE_6'], selected: false },
  { value: 'S7', name: 'Estado 7', description: 'Quieto entre 1440 y 4320 minutos', avatar: colorVehicleState['STATE_7'], selected: false },
  { value: 'S8', name: 'Estado 8', description: 'Quieto entre 4320 y 43200 minutos', avatar: colorVehicleState['STATE_8'], selected: false },
  { value: 'S9', name: 'Estado 9', description: 'Quieto mayor a 43200 minutos', avatar: colorVehicleState['STATE_9'], selected: false }
]

export {
  vehicleStates
}



// WEBPACK FOOTER //
// ./src/utils/vehicleStates.js